import ServiceMasterPassword from"./ServiceMasterPassword";export default ServiceMasterPassword;